<template>
  <div class="portfolio-items">
    <h3 class="portfolio-items--click" @click="changeVisibility">
      {{ portfolio.title.rendered }}
    </h3>
    <slider
      animation="fade"
      :speed="1000"
      :auto="false"
      :indicators="showIndicators"
      :control-btn="showButtons"
    >
      <div
        class="portfolio-info-label"
        @click="changeVisibility"
        v-if="getLanguagePL"
      >
        INFO
      </div>
      <div
        class="portfolio-info-label"
        @click="changeVisibility"
        v-if="getLanguageUA"
      >
        Інфо
      </div>
      <div
        class="portfolio-info-label"
        @click="changeVisibility"
        v-if="getLanguageEN"
      >
        INFO
      </div>
      <div
        class="portfolio-info-label"
        @click="changeVisibility"
        v-if="getLanguageES"
      >
        INFO
      </div>
      <slider-item v-for="(slide, index) in list" :key="index">
        <img
          :src="slide.url"
          class="portfolio-items__image"
          @click="changeVisibility"
          style="cursor:pointer;"
        />
      </slider-item>
    </slider>

    <div class="portfolio-popup" v-show="portfolioVisibility">
      <div class="portfolio-popup__overcontainer">
        <div class="portfolio-popup__container">
          <div class="portfolio-popup__container--close">
            <a @click="changeVisibility">
              <i class="fa fa-close"></i>
            </a>
          </div>
          <div class="portfolio-popup__container__image">
            <slider
              animation="fade"
              :speed="1000"
              :auto="false"
              :indicators="showIndicators"
              :control-btn="showButtons"
            >
              <slider-item v-for="(slide, index) in list" :key="index">
                <img :src="slide.url" class="portfolio-items__image" />
              </slider-item>
            </slider>
            <ul v-if="getLanguagePL">
              <li>Adres: {{ portfolio.acf.adres_do_wyswietlenia }}</li>
              <li>
                Dostępność:
                <a href="#dostepnosc" @click="changeVisibility"
                  >Sprawdź dostępność</a
                >
              </li>
            </ul>
            <ul v-if="getLanguageEN">
              <li>Adressess: {{ portfolio.acf.adres_do_wyswietlenia }}</li>
              <li>
                Availability:
                <a href="#dostepnosc" @click="changeVisibility"
                  >Check Availability</a
                >
              </li>
            </ul>
            <ul v-if="getLanguageUA">
              <li>Адреса: {{ portfolio.acf.adres_do_wyswietlenia }}</li>
              <li>
                Наявність:
                <a href="#dostepnosc" @click="changeVisibility"
                  >Перевірити наявність</a
                >
              </li>
            </ul>
            <ul v-if="getLanguageES">
              <li>Dirección: {{ portfolio.acf.adres_do_wyswietlenia }}</li>
              <li>
                Disponibilidad:
                <a href="#dostepnosc" @click="changeVisibility"
                  >Consulta disponibilidad</a
                >
              </li>
            </ul>
            <iframe
              width="100%"
              height="350"
              frameborder="0"
              style="border:0"
              :src="mapsAdres"
              allowfullscreen
            >
            </iframe>
          </div>
          <div class="portfolio-popup__container__content">
            <h3 class="portfolio-popup__container__content__title">
              {{ portfolio.title.rendered }}
            </h3>
            <span v-html="portfolio.content.rendered"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Slider, SliderItem } from "vue-easy-slider";
export default {
  data() {
    return {
      portfolioVisibility: false,
      list: this.portfolio.acf.galeria,
      showIndicators: this.portfolio.acf.galeria.length > 1 ? "center" : false,
      showButtons: this.portfolio.acf.galeria.length > 1,
      mapsAdres:
        "https://www.google.com/maps/embed/v1/place?key=AIzaSyBOd6ZrLJa1kSCQYrp6ucDElSkUVddLoPQ&q=" +
        this.portfolio.acf.adres.lat +
        "," +
        this.portfolio.acf.adres.lng
    };
  },
  methods: {
    changeVisibility() {
      jQuery(".fusion-header-wrapper").toggleClass("visibility-index");
      if (!this.portfolioVisibility) {
        jQuery("html").css("overflow", "hidden");
      } else {
        jQuery("html").css("overflow", "auto");
      }
      return (this.portfolioVisibility = !this.portfolioVisibility);
    }
  },
  computed: {
    getLanguagePL() {
      return document.documentElement.lang === "pl-PL";
    },
    getLanguageEN() {
      return document.documentElement.lang === "en-US";
    },
    getLanguageUA() {
      return document.documentElement.lang === "uk-UA";
    },
    getLanguageES() {
      return document.documentElement.lang === "es-ES";
    }
  },
  props: ["portfolio"],
  components: {
    Slider,
    SliderItem
  }
};
</script>
<style>
ul {
  list-style-type: none;
  padding-left: 10px;
}

.portfolio-info-label {
  color: #fff;
  position: absolute;
  right: 0;
  top: 0;
  padding: 0 10px;
  z-index: 1000;
  cursor: pointer;
  background: #ec8900;
}

.portfolio-items .slider {
  margin: 10px;
  height: 300px;
}

.portfolio-popup .slider-item {
  display: flex;
}

.portfolio-items--click,
.portfolio-items--preview {
  cursor: pointer;
}
.portfolio-popup__overcontainer {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
}
.portfolio-popup__container {
  background: #fff;
  width: 95%;
  height: 95%;
  color: #333;
  position: relative;
  padding: 30px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  overflow-y: auto;
}

.portfolio-popup__container--close {
  position: absolute;
  color: #333;
  cursor: pointer;
  right: 20px;
  top: 15px;
  font-size: 30px;
}

.portfolio-popup {
  position: fixed;
  width: 100%;
  background: rgba(0, 0, 0, 0.7);
  height: 100%;
  z-index: 99999999;
  display: inline-block;
  top: 0;
  left: 0;
}
.portfolio-items h3 {
  text-align: center;
  color: #005500;
  padding: 20px 5px 0px 5px;
}
.portfolio-items .portfolio-items--preview {
  width: 100%;
  height: 300px;
  object-fit: cover;
  padding: 5px;
}
.portfolio-popup__container__image {
  height: 100%;
}

.portfolio-popup__container__content ul {
  list-style-type: initial;
}

.portfolio-popup__container__image,
.portfolio-popup__container__content {
  padding: 20px;
}
.portfolio-popup__container__content__title {
  padding-top: 0px;
  margin-top: 0px;
}

@media all and (min-width: 1200px) {
  .portfolio-items {
    width: 33%;
  }
  .portfolio-popup__container__image {
    max-width: 60%;
  }
  .portfolio-popup__container__content {
    max-width: 40%;
  }
  .portfolio-items__image {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .portfolio-popup__container__image .portfolio-items__image {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .portfolio-popup__container__image .slider {
    width: 50vw !important;
  }
}

@media all and (min-width: 800px) and (max-width: 1199px) {
  .portfolio-items {
    width: 50%;
  }
  .portfolio-popup__container__image {
    width: 50%;
  }
  .portfolio-popup__container__content {
    width: 50%;
  }

  .portfolio-items__image {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .portfolio-popup__container__image .portfolio-items__image {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .portfolio-popup__container__image .slider {
    width: 40vw !important;
  }
}

@media all and (max-width: 799px) {
  .portfolio-items {
    width: 100%;
  }
  .portfolio-popup__container {
    flex-direction: column;
  }
  .portfolio-popup__container__image {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  .portfolio-popup__container__content {
    width: 100%;
  }

  .portfolio-items__image {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .portfolio-popup__container__image .portfolio-items__image {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .portfolio-popup__container__image .slider {
    width: 80vw !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/portfolioComponents/Card.vue